import { Unionize } from "./generic";

/*
 * Any types that exists only for the purpose of analytics events.
 */

/**
 * The location of the menu/buttons from which a new item is created.
 */
export const NewItemSource = ["homepage", "sidebar", "new-item-button"] as const;
export type NewItemSource = Unionize<typeof NewItemSource>;

export const EntityMenuSource = ["entity-list", "search-results-list", "home-page-recent-item"] as const;
export type EntityMenuSource = Unionize<typeof EntityMenuSource>;

export const StarEventSource = [...EntityMenuSource, "home-page-recent-item-direct", "topbar", "undo"] as const;
export type StarEventSource = Unionize<typeof StarEventSource>;

/**
 * Location of subscription actions, e.g. purchase links or upgrade buttons.
 */
export const SubscriptionActionSource = ["homepage", "settings"] as const;
export type SubscriptionActionSource = Unionize<typeof SubscriptionActionSource>;

export const SubscriptionManageSource = ["get-started", "manage", "checkout"] as const;
export type SubscriptionManageSource = Unionize<typeof SubscriptionManageSource>;

export const PageMenuSection = ["project", "view", "attachment", "help"] as const;
export type PageMenuSection = Unionize<typeof PageMenuSection>;

export const SystemOfMeasurementUpdateSource = ["project-settings", "scenario-configuration"] as const;
export type SystemOfMeasurementUpdateSource = Unionize<typeof SystemOfMeasurementUpdateSource>;
